export default __webpack_public_path__ + "static/media/doctor.84c33e19.png";